module.exports = __webpack_public_path__ + "media/images/logo-other-dc0cb375e6d9c0f2e29b35f2fae3fa4e.png";